import axios from 'axios'


//var url="http://192.168.31.65:6315"
var url="http://192.168.31.108:6315"
//var url="http://10.81.0.40:6315"
const instance=axios.create({
    baseURL:url
})
export default instance